import { createRoute, useParams } from "@tanstack/solid-router";
import { useNavigate } from "@/lib/u-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@/components/ui/page-container";

/**
 * `/admin/email/$templateId` — editor de edición de plantilla addressable por URL
 * (campaña #15b). Antes era un signal local (`editing`) sin URL propia. Si el id
 * no existe, el manager muestra un `NotFoundState` (no un editor vacío).
 * Segmento dinámico: `new` y `campaigns` (estáticos) ganan al matchear.
 */
function AdminEmailEditPage() {
  const navigate = useNavigate();
  const params = useParams({ from: adminEmailEditRoute.id });
  const back = () => {
    void navigate({ to: "/admin/email" });
  };
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager
        mode={() => "edit"}
        editId={() => params().templateId}
        onClose={back}
        onNew={() => {
          void navigate({ to: "/admin/email/new" });
        }}
        onEdit={(id) => {
          void navigate({ to: "/admin/email/$templateId", params: { templateId: id } });
        }}
      />
    </PageContainer>
  );
}

export const adminEmailEditRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email/$templateId",
  component: AdminEmailEditPage,
});
